export default __webpack_public_path__ + "static/media/19.1fc1a6c7.png";